module.exports = __webpack_public_path__ + "img/img_sample.48842eb.png";